<h4 mat-dialog-title>Edition du contenu du champ label</h4>
<mat-divider></mat-divider>
<form (ngSubmit)="onSubmit()" [formGroup]="editLabelInputForm" style="margin-top: 20px">
    <mat-dialog-content class="mat__typography" style="height: 300px;">
        <div fxLayout="column" fxLayoutGap="15px">
          <quill-editor style="height: 250px;" formControlName="content"
                        [modules]="modules"
                        [formats]="formats"
                        [placeholder]="'Votre texte...'">
          </quill-editor>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button (click)="onNoClick()"
                mat-raised-button
                color="primary"
                type="button"
                data-cy="button-label-input-dialog-cancel">
            Annuler
        </button>
        <button mat-raised-button
                cdkFocusInitial
                color="accent"
                type="submit"
                data-cy="button-label-input-dialog-save">
            Sauvegarder
        </button>
    </mat-dialog-actions>
</form>
